/****************************************************
 * Module Name:  cancelMixSale.js
 * Project:      Pansuriya Impex Sales & Manufacturing
 * Owner:        info@pansuriyaimpex.com
 *
 * Copyright (c) Pansuriya Impex
 * All rights reserved.
 ****************************************************/

import React, { useState, useEffect } from "react";
import MixSaleProxy from "../../utility/proxy/manager/mixProxy/mixSalesProxy";
import Constants from "../../utility/constants";
import { Box, Button, CircularProgress, Stack, TextField, Tooltip, Typography } from "@mui/material";
import Select from "react-select";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import { LoadingButton } from "@mui/lab";
import SearchOutlinedIcon from "@mui/icons-material/SearchOutlined";
import { DataGridPro, GridToolbar, GridToolbarExport, GridToolbarColumnsButton, GridToolbarContainer, GridToolbarFilterButton, GridToolbarQuickFilter } from "@mui/x-data-grid-pro";
import RefreshOutlinedIcon from "@mui/icons-material/RefreshOutlined";
import Utility from "../../utility/utility";
import renderCellExpand from "../common/dataGridCellExpand";
import { BsFilePdf } from "react-icons/bs";
import CheckIcon from "@mui/icons-material/Check";
import ClearIcon from "@mui/icons-material/Clear";
import PDFModal from "../common/pdfModal";
import BucketDetailModal from "./bucketDetailModal";
import { Cancel } from "@mui/icons-material";
import { Modal } from "react-bootstrap";
import logo from '../../images/pansuriya.jpg'
import StoneProxy from "../../utility/proxy/manager/stoneProxy";
import CommonSnackbar from "../common/commonSnackBar";
import PageTitle from "../common/pageTitle";
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import UserDetailModal from "../operations/userDetailModal";

const CancelMixSale = () => {

    const mixSaleCancelPermission = Constants.USER_PERMISSION.filter((iPermission) =>
        iPermission.permissionid === Constants.PERMISSIONS.MIX_SALES_CANCEL_SALE);

    const [customerOptions, setCustomerOptions] = useState([]);
    const [customer, setCustomer] = useState([]);
    const [fromDate, setFromDate] = useState();
    const [toDate, setToDate] = useState();
    const [showBucketDetailModal, setShowBucketDetailModal] = useState(false);
    const [bucketId, setBucketId] = useState([]);
    const [rows, setRows] = useState([]);
    const [loader, setLoader] = useState(false);
    const [filterValues, setFilterValues] = useState([]);
    const [pdfName, setPdfName] = useState("");
    const [pdfByte, setPdfByte] = useState("");
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [mainData, setMainData] = useState([]);

    const [showCancelModal, setShowCancelModal] = useState(false);
    const [invoiceId, setInvoiceId] = useState("");

    const [showSnackbar, setShowSnackbar] = useState(false);
    const [snackbarMessage, setSnackbarMessage] = useState("");
    const [snackbarVariant, setSnackbarVariant] = useState("");

    const [showUserDetailModal, setShowUserDetailModal] = useState(false);

    useEffect(() => {
        PageTitle("MIX_SALES_CANCEL_SALE");
        getAllCustomer();
        setFromDate(new Date());
        setToDate(new Date());
    }, []);

    const getAllCustomer = () => {
        let usertype = Constants.loggedInUser.usertype;
        MixSaleProxy.GetCustomersCreatedInvoice(-1, -1, usertype, (response) => {
            if (response) {
                setAllCustomer(response);
            }
        });
    };

    const setAllCustomer = (response) => {
        let optionsArray = [];
        optionsArray.push({ value: -1, label: "-- ANY --" });
        response.forEach((data) => {
            let option = { value: data.id, label: data.companyname };
            optionsArray.push(option);
        });

        setCustomerOptions(optionsArray);
        setCustomer([optionsArray[0]]);
    }

    const handleBucketDetailModal = (params) => {
        setBucketId(params.value);
        setShowBucketDetailModal(true)
    };

    const handleArray = (lListData) => {
        let newMainData = [];
        if (lListData.length > 0) {
            lListData.map((list) => {
                list.buckets.map((stone) => newMainData.push(stone));
                return true;
            });
        }
        setMainData(newMainData);
    };

    const handleSearch = () => {
        setLoader(true);
        let tempCustomer = customer.find(c => c.value === -1) ?
            customerOptions.map(c => c.value) :
            customer.map(c => c.value);
        let data = {
            from: dayjs(fromDate).format('YYYY-MM-DD') + "T00:00:00.000Z",
            to: dayjs(toDate).format('YYYY-MM-DD') + "T23:59:59.999Z",
            users: tempCustomer,
            status: ["PAID", "UNPAID"],
            locationid: -1
        }

        MixSaleProxy.GetAllMixInvoiceReport(Constants.loggedInUser.id, Constants.loggedInUser.usertype, data, (response) => {
            if (response) {
                const uniqueFilterValues = {
                    status: Utility.getDistinctOptions(response, "status"),
                    exchangecurrency: Utility.getDistinctOptions(response, "exchangecurrency"),
                    user: Utility.getDistinctOptions(response, "userid"),
                    broker: Utility.getDistinctOptions(response, "brokerid"),
                    customer: Utility.getDistinctOptions(response, "customerid"),
                    invoicecustomer: Utility.getDistinctOptions(response, "invoicecustomerid"),
                    tradingcompany: Utility.getDistinctOptions(response, "tradingcompanyid"),
                };

                const bucketNames = [];
                response.forEach(item => {
                    if (item.buckets && item.buckets.length > 0) {
                        item.buckets.forEach(bucket => {
                            const bucketName =
                                `${bucket.stonetypefullname} | ${bucket.shape} | ${bucket.size} | ${bucket.color} | ${bucket.clarity}`;
                            if (!bucketNames.includes(bucketName)) {
                                bucketNames.push(bucketName);
                            }
                        });
                    }
                });

                const combinedFilterValues = {
                    status: uniqueFilterValues.status,
                    exchangecurrency: uniqueFilterValues.exchangecurrency,
                    user: uniqueFilterValues.user.map(value => {
                        const matchingItem = response.find(item => item.userid === value);
                        return matchingItem ? `${value} | ${matchingItem.username}` : [];
                    }),
                    broker: uniqueFilterValues.broker.map(value => {
                        const matchingItem = response.find(item => item.brokerid === value);
                        if (matchingItem) {
                            let displayValue = matchingItem.brokerid === -1 ? " - " : `${matchingItem.brokerid} | ${matchingItem.brokername}`;
                            return displayValue;
                        }
                        return [];
                    }),
                    customer: uniqueFilterValues.customer.map(value => {
                        const matchingItem = response.find(item => item.customerid === value);
                        return matchingItem ? `${value} | ${matchingItem.customername}` : [];
                    }),
                    tradingcompany: uniqueFilterValues.tradingcompany.map(value => {
                        const matchingItem = response.find(item => item.tradingcompanyid === value);
                        return matchingItem ? `${value} | ${matchingItem.tradingcompanyname}` : [];
                    }),
                    bucketname: bucketNames,
                };
                setFilterValues(combinedFilterValues);
                setRows(response);
                handleArray(response);
                setLoader(false);
            } else {
                setLoader(false);
                // setErrorSnackbar(true);
            }
        });
    }

    const cancelInvoice = () => {
        setLoader(true);
        StoneProxy.CancelMixSale(invoiceId, (response) => {
            if (response.status === "Success") {
                setLoader(false);
                setShowCancelModal(false);
                handleSearch();
                setShowSnackbar(true);
                setSnackbarMessage(response.errorMessage);
                setSnackbarVariant("success");
            } else {
                setLoader(false);
                setShowCancelModal(false);
                setShowSnackbar(true);
                setSnackbarMessage(response.errorMessage);
                setSnackbarVariant("error");
            }
        })
    }

    const columnName = [
        {
            field: "id",
            headerName: "ID",
            headerAlign: "center",
            width: 80,
            type: "number",
            valueFormatter: (params) => params.value,
            align: "center",
        },
        {
            field: "bucketid",
            headerName: "BUCKETID",
            headerAlign: "center",
            align: "center",
            width: 80,
            type: "number",
            valueFormatter: (params) => params.value,
            renderCell: (params) => (Utility.NeedToShowBucketDetailModal()) ?
                <Button
                    sx={{
                        textDecorationLine: "underline",
                        color: 'black'
                    }}
                    onClick={() => handleBucketDetailModal(params)}
                >
                    {params.value}
                </Button>
                :
                <div>{params.value}</div>,
        },
        {
            field: "bucketname",
            headerName: "BUCKET NAME",
            headerAlign: "center",
            align: "center",
            width: 300,
            type: "singleSelect",
            valueOptions: filterValues ? filterValues.bucketname : [],
            filterOperators: Utility.combinedFilters(),
            valueGetter: (params) =>
                params.row.stonetypefullname +
                " | " +
                params.row.shape +
                " | " +
                params.row.size +
                " | " +
                params.row.color +
                " | " +
                params.row.clarity,
            renderCell: (params) =>
                params.row.stonetypefullname +
                " | " +
                params.row.shape +
                " | " +
                params.row.size +
                " | " +
                params.row.color +
                " | " +
                params.row.clarity,
        },
        {
            field: "qty",
            headerName: "QTY",
            headerAlign: "center",
            align: "center",
            type: "number",
            valueFormatter: (params) => params.value,
            width: 55,
        },
        {
            field: "piece",
            headerName: "PIECES",
            headerAlign: "center",
            align: "center",
            type: "number",
            valueFormatter: (params) => params.value,
            width: 70,
        },
        {
            field: "sellqty",
            headerName: "SELL QTY",
            headerAlign: "center",
            type: "number",
            valueFormatter: (params) => params.value,
            align: "center",
            width: 80,
        },
        {
            field: "price",
            headerName: "PPC",
            headerAlign: "center",
            type: "number",
            align: "center",
            width: 70,
            valueFormatter: (params) => params.value,
            renderCell: (params) => Utility.ConvertNumberWithSpecifiedDigits(params.row.price)
        },
        {
            field: "discount1",
            headerName: "DIS 1",
            headerAlign: "center",
            align: "center",
            type: "number",
            valueFormatter: (params) => params.value,
            width: 55,
        },
        {
            field: "discount2",
            headerName: "DIS 2",
            headerAlign: "center",
            type: "number",
            valueFormatter: (params) => params.value,
            align: "center",
            width: 55,
        },
        {
            field: "discount3",
            headerName: "DIS 3",
            headerAlign: "center",
            align: "center",
            type: "number",
            valueFormatter: (params) => params.value,
            width: 55,
        },
        {
            field: "final_amount",
            headerName: "FINAL AMOUNT",
            headerAlign: "center",
            align: "center",
            width: 110,
            type: "number",
            valueFormatter: (params) => params.value,
            renderCell: (params) => Utility.ConvertNumberWithSpecifiedDigits(params.row.final_amount)
        },
        {
            field: "remarks",
            headerName: "REMARKS",
            headerAlign: "center",
            align: "center",
            width: 90,
        },
    ];

    const materialDefaultColumns = [
        {
            headerName: "CANCEL SALE",
            field: "cancelsale",
            width: 160,
            headerAlign: "center",
            hide: Utility.isUpdateAllowed(mixSaleCancelPermission) || Utility.isDeleteAllowed(mixSaleCancelPermission) ? false : true,
            renderCell: (params) => (
                <Tooltip title="Cancel Sale">
                    <Button
                        variant="contained"
                        component="label"
                        size="small"
                        startIcon={<Cancel size="large" />}
                        color="primary"
                        onClick={() => {
                            setShowCancelModal(true);
                            setInvoiceId(params.row.id);
                        }}
                    >
                        Cancel Sale
                    </Button>
                </Tooltip>
            ),
        },
        {
            headerName: "INVOICE ID",
            field: "id",
            headerAlign: "center",
            width: 115,
            type: "number",
            valueFormatter: (params) => params.value,
            align: "center",
            renderCell: renderCellExpand
        },
        {
            headerName: "STONETYPE",
            field: "stonetype",
            headerAlign: "center",
            align: "center",
            type: "singleSelect",
            valueOptions: Constants.uniqueFilterValues.stonetype.map(option => option.fullname),
            filterOperators: Utility.combinedFilters(),
            valueGetter: (params) => Constants.STONE_TYPE[params.value],
            renderCell: (params) => Constants.STONE_TYPE[params.value],
            width: 115,
        },
        {
            headerName: "USER",
            field: "userid",
            width: 185,
            type: "singleSelect",
            valueOptions: filterValues ? filterValues.user : [],
            filterOperators: Utility.combinedFilters(),
            headerAlign: "center",
            align: "center",
            valueGetter: (params) => {
                return `${params.row.userid} | ${params.row.username}`;
            },
            renderCell: (params) => (
                <div style={{ display: 'flex', alignItems: 'center' }}>
                    <span style={{ marginRight: '5px', marginLeft: '10px' }}>
                        {`${params.row.userid} | ${params.row.username}`}
                    </span>
                </div>
            ),
        },
        {
            headerName: "BROKER COMPANY",
            field: "brokerid",
            width: 185,
            type: "singleSelect",
            valueOptions: filterValues ? filterValues.broker : [],
            filterOperators: Utility.combinedFilters(),
            valueGetter: (params) => {
                return params.row.brokerid === -1 ? " - " : `${params.row.brokerid} | ${params.row.brokercompanyname}`;
            },
            renderCell: (params) => {
                let displayValue = params.row.brokerid === -1 ? " - " : `${params.row.brokerid} | ${params.row.brokercompanyname}`
                return (
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                        <span style={{ marginRight: '5px', marginLeft: '10px' }}>
                            {(params.row.brokerid === -1 || params.row.brokerid === null) ? " - " : displayValue}
                        </span>
                    </div>
                );
            },
            headerAlign: "center",
            align: "center",
        },
        {
            headerName: "CUSTOMER COMPANY",
            field: "customerid",
            width: 225,
            type: "singleSelect",
            valueOptions: filterValues ? filterValues.customer : [],
            filterOperators: Utility.combinedFilters(),
            valueGetter: (params) => {
                return `${params.row.customerid} | ${params.row.customercompanyname}`;
            },
            renderCell: (params) => {
                return (
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                        <span style={{ marginRight: '5px', marginLeft: '10px' }}>
                            {`${params.row.customerid} | ${params.row.customercompanyname}`}
                        </span>
                    </div>
                );
            },
            headerAlign: "center",
            align: "center",
        },
        {
            headerName: "TRADING COMPANY",
            field: "tradingcompanyid",
            width: 200,
            type: "singleSelect",
            valueOptions: filterValues ? filterValues.tradingcompany : [],
            filterOperators: Utility.combinedFilters(),
            valueGetter: (params) => {
                return `${params.row.tradingcompanyid} | ${params.row.tradingcompanyname}`;
            },
            renderCell: (params) => {
                return (
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                        <span style={{ marginRight: '5px', marginLeft: '10px' }}>
                            {`${params.row.tradingcompanyid} | ${params.row.tradingcompanyname}`}
                        </span>
                    </div>
                );
            },
            headerAlign: "center",
            align: "center",
        },
        {
            headerName: "EXCHANGE CURRENCY",
            field: "exchangecurrency",
            headerAlign: "center",
            align: "center",
            type: "singleSelect",
            width: 170,
            valueOptions: filterValues ? filterValues.exchangecurrency : [],
            filterOperators: Utility.combinedFilters(),
            renderCell: renderCellExpand
        },
        {
            headerName: "EXCHANGE RATE",
            field: "exchangerate",
            headerAlign: "center",
            type: "number",
            valueFormatter: (params) => params.value,
            align: "center",
            width: 130,
            renderCell: renderCellExpand
        },
        {
            headerName: "DAYS",
            field: "days",
            headerAlign: "center",
            width: 55,
            align: "center",
            renderCell: renderCellExpand
        },
        {
            headerName: "SHIPPING COST",
            field: "shippingcost",
            headerAlign: "center",
            type: "number",
            valueFormatter: (params) => params.value,
            align: "center",
            width: 110,
            renderCell: renderCellExpand
        },
        {
            headerName: "PDF",
            field: "invoicepdf",
            renderCell: (params) => (
                <BsFilePdf size={25} color="red" onClick={() => downloadPDF(params.row.id, params.row.invoicepdf)} />
            ),
            export: false,
            headerAlign: "center",
            align: "center",
        },
        {
            headerName: "FINAL PAYABLE AMOUNT",
            field: "finalpayableamount",
            headerAlign: "center",
            type: "number",
            valueFormatter: (params) => params.value,
            align: "center",
            width: 170,
            renderCell: renderCellExpand
        },
        {
            headerName: "PAID AMOUNT",
            field: "amountpaid",
            headerAlign: "center",
            type: "number",
            valueFormatter: (params) => params.value,
            align: "center",
            width: 110,
            renderCell: renderCellExpand
        },
        {
            headerName: "DATE",
            field: "date",
            type: "date",
            width: 85,
            valueGetter: (params) => {
                if (params.value) {
                    return new Date(params.value);
                }
                return null;
            },
            renderCell: (params) => Utility.ConvertUtcToLocalDate(params.row.date),
            headerAlign: "center",
            align: "center",
        },
        {
            headerName: "EXPORT",
            field: "export",
            renderCell: (params) =>
                params.row.export ? (
                    <CheckIcon color="success" />
                ) : (
                    <ClearIcon color="error" />
                ),
            headerAlign: "center",
            align: "center",
            width: 65
        },
        {
            headerName: "COUNTRY OF FINAL DESTINATION",
            field: "countryoffinaldestination",
            headerAlign: "center",
            align: "center",
            width: 220,
            renderCell: renderCellExpand
        },
        {
            headerName: "COUNTRY OF ORIGIN",
            field: "countryoforigin",
            headerAlign: "center",
            width: 145,
            align: "center",
            renderCell: renderCellExpand
        },
        {
            headerName: "FINAL DESTINATION",
            field: "finaldestination",
            headerAlign: "center",
            align: "center",
            width: 135,
            renderCell: renderCellExpand
        },
        {
            headerName: "ENSURED BY",
            field: "ensuredby",
            headerAlign: "center",
            align: "center",
            width: 95,
            renderCell: renderCellExpand
        },
        {
            headerName: "BANK THROUGH",
            field: "bankthrough",
            renderCell: (params) =>
                params.row.bankthrough ? (
                    <CheckIcon color="success" />
                ) : (
                    <ClearIcon color="error" />
                ),
            headerAlign: "center",
            width: 115,
            align: "center",
        },
        {
            headerName: "PORT OF LOADING",
            field: "portofloading",
            headerAlign: "center",
            align: "center",
            width: 130,
            renderCell: renderCellExpand
        },
        {
            headerName: "SHIPPED BY",
            field: "shippedby",
            headerAlign: "center",
            align: "center",
            renderCell: renderCellExpand
        },
        {
            headerName: "PORT OF DISCHARGE",
            field: "portofdischarge",
            headerAlign: "center",
            align: "center",
            width: 150,
            renderCell: renderCellExpand
        },
        {
            headerName: "REMARKS",
            field: "remarks",
            headerAlign: "center",
            align: "center",
            width: 75,
            renderCell: renderCellExpand
        },
        {
            headerName: "TERMS",
            field: "terms",
            headerAlign: "center",
            type: "number",
            width: 60,
            valueFormatter: (params) => params.value,
            align: "center",
            renderCell: renderCellExpand
        },
        {
            headerName: "DUE DATE",
            field: "duedate",
            type: "date",
            width: 85,
            valueGetter: (params) => {
                if (params.value) {
                    return new Date(params.value);
                }
                return null;
            },
            renderCell: (params) => Utility.ConvertUtcToLocalDate(params.row.duedate),
            headerAlign: "center",
            align: "center",
        }
    ];

    const downloadPDF = (invoiceid, fileBytes) => {
        setPdfByte(fileBytes);
        setPdfName(`Invoice` + invoiceid + `.pdf`);
        openModal();
    }

    const openModal = () => {
        setIsModalOpen(true);
    };

    const closeModal = () => {
        setIsModalOpen(false);
    };

    const columns = columnName;

    const getDetailPanelHeight = React.useCallback(() => 'auto', []);

    const getDetailPanelContent = React.useCallback(
        (row, mainData) => <DetailPanelContent row={row} mainData={mainData} />,
        [columns],
    );

    function DetailPanelContent({ row: rowProp, mainData }) {
        let row = mainData.filter(data => data.invoiceid === rowProp.id);
        return (
            <Stack
                sx={{ p: 1, height: '100%', boxSizing: 'border-box', borderBottom: "1px solid lightgrey" }}
                direction="column"
            >
                <Box
                    sx={{
                        backgroundColor: '#fff',
                        color: '#000',
                        width: "53.5vw",
                        position: "relative",
                        "& .MuiTablePagination-selectLabel": {
                            marginTop: "15px",
                        },
                        "& .MuiTablePagination-displayedRows": {
                            marginTop: "15px",
                        },
                        "& .css-1jbbcbn-MuiDataGrid-columnHeaderTitle": {
                            fontWeight: Constants.defaultFontWeight,
                        },
                        "& .css-1knaqv7-MuiButtonBase-root-MuiButton-root": {
                            color: "#1976d2",
                            padding: "4px 5px",
                            borderRadius: "4px",
                        },
                        "& .css-cc8tf1": {
                            fontWeight: Constants.defaultFontWeight,
                        },
                        height: 'auto'
                    }}
                >
                    <DataGridPro
                        disableRowSelectionOnClick={false}
                        density="compact"
                        columns={columns}
                        rows={row}
                        getRowId={(row) => row.id}
                        sx={{
                            '& .MuiDataGrid-columnHeader': {
                                color: '#fff',
                                backgroundColor: 'grey',
                            },
                            "&.MuiDataGrid-root--densityCompact .MuiDataGrid-cell": {
                                py: "8px",
                            },
                            "&.MuiDataGrid-root--densityStandard .MuiDataGrid-cell": {
                                py: "15px",
                            },
                            "&.MuiDataGrid-root--densityComfortable .MuiDataGrid-cell": {
                                py: "22px",
                            },

                            fontSize: Constants.defaultTableFontSize, fontWeight: Constants.defaultFontWeight,
                            maxHeight: '35vh'
                        }}
                        slots={{ toolbar: GridToolbar }}
                        slotProps={{
                            toolbar: {
                                showQuickFilter: true,
                                quickFilterProps: { debounceMs: 500 },
                            },
                        }}
                        initialState={{
                            columns: {
                                columnVisibilityModel: {
                                    // Hide columns id, the other columns will remain visible
                                    perfomaid: false,
                                    id: false,
                                },
                            },
                        }}
                        hideFooter
                    />
                </Box>
            </Stack>
        );
    }

    function CustomToolbar() {
        return (
            <GridToolbarContainer
                sx={{
                    display: "flex",
                    alignItems: "center",
                    marginHorizontal: "5px",
                    "&.MuiDataGrid-toolbarContainer": {
                        padding: "0px 4px !important",
                    },
                }}
            >
                <GridToolbarColumnsButton />
                <GridToolbarFilterButton />
                <GridToolbarExport />
                <Box sx={{ flexGrow: 1, display: { sm: "none", md: "block" } }} />
                {loader ? (
                    <CircularProgress size="1rem" />
                ) : (
                    <Tooltip title="Reload List">
                        <RefreshOutlinedIcon
                            onClick={() => handleSearch()}
                            color="primary"
                            fontSize="medium"
                            sx={{ cursor: "pointer", mt: 1 }}
                        />
                    </Tooltip>
                )}
                <GridToolbarQuickFilter debounceMs={500} />
            </GridToolbarContainer>
        );
    }

    return (
        <div>

            {Utility.isReadAllowed(mixSaleCancelPermission) ? (
                <Box>

                    <CommonSnackbar
                        show={showSnackbar}
                        message={snackbarMessage}
                        variant={snackbarVariant}
                        autoHide={Constants.SnackBarCloseTimer}
                        title={snackbarVariant === "success" ? "Success" : snackbarVariant === "error" ? "Failed" : "Warning"}
                        handleClose={() => setShowSnackbar(false)}
                    />

                    {showBucketDetailModal ? (
                        <BucketDetailModal
                            show={showBucketDetailModal}
                            bucketId={bucketId}
                            handleClose={() => setShowBucketDetailModal(false)}
                        />
                    ) : null}

                    {showUserDetailModal ? (
                        <UserDetailModal
                            show={true}
                            handleClose={() => setShowUserDetailModal(false)}
                            handleSelect={(selectedOption) => {
                                const selectedCustomers = customerOptions.filter(opt =>
                                    selectedOption.includes(opt.value)
                                );
                                setCustomer(selectedCustomers);
                                setShowUserDetailModal(false)
                            }}
                            userids={customerOptions.map(cust => cust.value)}
                            selectedIds={customer.length !== 0 ? customer.map(iCustomer => iCustomer.value) : []}
                            usertype={"C"}
                            loading={showUserDetailModal}
                            isMulti={true}
                        />
                    ) : null}

                    {/*need to send pdf in byte string to modal */}
                    <PDFModal show={isModalOpen} onHide={closeModal} pdfByteString={pdfByte} pdfName={pdfName} />

                    <Box
                        sx={{
                            display: "flex",
                            flexWrap: "wrap",
                            alignItems: "center",
                            width: "100%",
                            mt: 1,
                            mb: 2,
                            gap: "8px",
                        }}
                    >
                        <Box
                            sx={{
                                display: "flex",
                                alignItems: "center",
                                gap: 1,
                                whiteSpace: "nowrap",
                            }}
                        >
                            <Typography sx={{ mr: 1 }}>Customer Company</Typography>
                            <Box sx={{ flexGrow: 1, minWidth: 0, display: "flex", alignItems: "center", gap: 1 }}>
                                <Select
                                    menuPlacement="auto"
                                    blurInputOnSelect={false}
                                    className="basic-single"
                                    classNamePrefix="select"
                                    menuPortalTarget={document.body}
                                    styles={{
                                        ...Constants.Styles,
                                        control: (base) => ({
                                            ...base,
                                            width: '23rem',
                                            minHeight: "36px",
                                        }),
                                    }}
                                    getOptionLabel={(option) => option.label}
                                    getOptionValue={(option) => option.value}
                                    isMulti
                                    options={customerOptions}
                                    value={customer}
                                    onChange={(selectedOption) => {
                                        setCustomer(selectedOption);
                                    }}
                                />

                                <Tooltip title="View More Data">
                                    <span style={{ cursor: "pointer" }}>
                                        <OpenInNewIcon
                                            fontSize="medium"
                                            color="action"
                                            onClick={() => setShowUserDetailModal(true)}
                                        />
                                    </span>
                                </Tooltip>
                            </Box>
                        </Box>

                        <Box sx={{ display: "flex", alignItems: "center" }}>
                            <Typography sx={{ whiteSpace: "nowrap", mr: 1 }}>From</Typography>
                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                                <DatePicker
                                    ampm={true}
                                    renderInput={(props) => (
                                        <TextField
                                            {...props}
                                            size="small"
                                            sx={{ width: "160px" }}
                                            inputProps={{ ...props.inputProps, readOnly: true }}
                                        />
                                    )}
                                    value={fromDate}
                                    inputFormat="DD/MM/YYYY"
                                    onChange={(newValue) => {
                                        // Get the current time
                                        const now = dayjs();

                                        // Set startOfMonth to the first day of the selected month, but with the current system time
                                        const fromDate = dayjs(newValue)
                                            .hour(now.hour())
                                            .minute(now.minute())
                                            .second(now.second())
                                            .millisecond(now.millisecond())
                                            .toDate();

                                        setFromDate(fromDate);
                                    }}
                                />
                            </LocalizationProvider>
                        </Box>

                        <Box sx={{ display: "flex", alignItems: "center" }}>
                            <Typography sx={{ whiteSpace: "nowrap", mr: 1 }}>To</Typography>
                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                                <DatePicker
                                    className="picker"
                                    ampm={true}
                                    renderInput={(props) => (
                                        <TextField
                                            {...props}
                                            size="small"
                                            sx={{ width: "160px" }}
                                            inputProps={{ ...props.inputProps, readOnly: true }}
                                        />
                                    )}
                                    error={false}
                                    value={toDate}
                                    inputFormat="DD/MM/YYYY"
                                    onChange={(newValue) => {
                                        // Get the current time
                                        const now = dayjs();

                                        // Set startOfMonth to the first day of the selected month, but with the current system time
                                        const toDate = dayjs(newValue)
                                            .hour(now.hour())
                                            .minute(now.minute())
                                            .second(now.second())
                                            .millisecond(now.millisecond())
                                            .toDate();

                                        setToDate(toDate);
                                    }}
                                />
                            </LocalizationProvider>
                        </Box>

                        <LoadingButton
                            loading={loader}
                            loadingPosition="start"
                            disabled={!customer}
                            variant="contained"
                            onClick={() => handleSearch()}
                            startIcon={<SearchOutlinedIcon size="large" />}
                        >
                            Search
                        </LoadingButton>
                    </Box>
                    <Box
                        sx={{
                            backgroundColor: '#fff',
                            color: '#000',
                            width: "100%",
                            position: "relative",
                            "& .MuiTablePagination-selectLabel": {
                                marginTop: "15px",
                            },
                            "& .MuiTablePagination-displayedRows": {
                                marginTop: "15px",
                            },
                            "& .css-1jbbcbn-MuiDataGrid-columnHeaderTitle": {
                                fontWeight: Constants.defaultFontWeight,
                            },
                            "& .css-cc8tf1": {
                                fontWeight: Constants.defaultFontWeight,
                            },
                            "& .lavenderCell": {
                                color: "#080808",
                                backgroundColor: "#D8BFD8",
                            },
                            height: "77vh",
                        }}
                    >
                        <DataGridPro
                            disableRowSelectionOnClick={false}
                            density="compact"
                            columns={materialDefaultColumns}
                            rows={rows}
                            loading={loader}
                            sx={{
                                '& .MuiDataGrid-columnHeader': {
                                    color: '#fff',
                                    backgroundColor: 'grey',
                                },
                                "&.MuiDataGrid-root--densityCompact .MuiDataGrid-cell": {
                                    py: "4px",
                                },
                                "&.MuiDataGrid-root--densityStandard .MuiDataGrid-cell": {
                                    py: "12px",
                                },
                                "&.MuiDataGrid-root--densityComfortable .MuiDataGrid-cell": {
                                    py: "18px",
                                },

                                '& .MuiDataGrid-row': {
                                    whiteSpace: 'nowrap',
                                },
                                fontSize: Constants.defaultTableFontSize,
                                fontWeight: Constants.defaultFontWeight,
                            }}
                            slots={{ toolbar: CustomToolbar }}
                            slotProps={{
                                toolbar: {
                                    showQuickFilter: true,
                                    quickFilterProps: { debounceMs: 500 },
                                },
                            }}
                            getRowId={(row) => row.id}
                            initialState={{
                                pagination: {
                                    paginationModel: Constants.pageSize,
                                },
                            }}
                            sortModel={[
                                {
                                    field: 'id',
                                    sort: 'desc',
                                },
                            ]}
                            pageSizeOptions={Constants.pageSizeOptions}
                            pagination
                            getDetailPanelHeight={getDetailPanelHeight}
                            getDetailPanelContent={({ row }) => getDetailPanelContent(row, mainData)}
                        />
                    </Box>
                </Box>
            ) : null}

            <Modal
                show={showCancelModal}
                onHide={() => setShowCancelModal(false)}
                backdrop="static"
                keyboard={true}
                centered
                enforceFocus={false}
            >
                <Modal.Header closeButton>
                    <Modal.Title>
                        <img
                            src={logo}
                            height="40pt"
                            width="40pt"
                            alt={Constants.COMPANY_SITE}
                        />
                        &nbsp;&nbsp;
                        Cancel sale
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Typography variant="h5">
                        Are you sure you want to cancel these invoice ?
                    </Typography>
                </Modal.Body>
                <Modal.Footer>
                    <LoadingButton
                        variant="contained"
                        onClick={cancelInvoice}
                        sx={{ mr: 3 }}
                        loading={loader}
                        loadingPosition="start"
                        startIcon={<ClearIcon />}
                    >
                        Cancel Sale
                    </LoadingButton>
                    <Button
                        variant="contained"
                        color="error"
                        onClick={() => setShowCancelModal(false)}
                        sx={{ mr: 2 }}
                        disabled={loader}
                    >
                        Close
                    </Button>
                </Modal.Footer>
            </Modal>

        </div>
    );
};

export default CancelMixSale;